import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { faLock } from '@fortawesome/free-solid-svg-icons';

type TooltipType =
  | 'chart'
  | 'map'
  | 'interactive'
  | 'simple'
  | 'data-explorer'
  | '';

export type TooltipOptions = {
  type: TooltipType;
  title?: string;
  chartDescription?: string;
  chartText?: string;
  chartCaption?: string;
  dailySpending?: any;
  people?: number;
  peopleCaption?: any;
  peopleCaptionTotal?: any;
  spending?: number;
  spendingCaption?: any;
  spendingCaptionTotal?: any;
  growth?: number;
  interactiveText?: string;
  interactiveLeft?: string;
  interactiveRight?: string;
  simpleText?: string;
  showLock?: boolean;
  loading?: boolean;
};

@Component({
  selector: 'mpro-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnInit {
  public faLock = faLock;

  @Input() title?: string;
  @Input() options: TooltipOptions;
  @HostBinding('class.data-explorer') get hideHost() {
    return this.options?.type === 'data-explorer';
  }

  growth: number = 0;

  @Output() next = new EventEmitter();
  @Output() back = new EventEmitter();

  ngOnInit() {
    if (this.options.growth) {
      this.growth = this.options.growth;
    } else {
      this.growth = 0;
    }
  }

  nextClick() {
    this.next.emit();
  }

  backClick() {
    this.back.emit();
  }
}
